
export abstract class ApiServiceBase {

    protected images = '/images/';
    protected authToken = 'auth/token';
    constructor(
        protected serviceUrl: string,
        protected siteAddressUrl: string,
        protected serviceCdnUrl: string
    ) {

    }

    protected getUrl(url: string) {
        return `${this.serviceUrl}${url}`;
    }

    protected getCDNUrl(url: string) {
        return `${this.serviceCdnUrl}${url}`;
    }

    wysiwygImage(guid?: string) {
        if (guid) {
            return this.getUrl(`image/${encodeURIComponent(guid)}`);
        } else {
            return this.getUrl('image');
        }
    }

    wysiwygImageCopy() {
        return this.getUrl('image/copy');
    }

    getWysiwygImageUrl(guid: string) {
        return `${this.siteAddressUrl}images/commonImage/${encodeURIComponent(guid)}`;
    }

    getCampaignImageUrl(id: number, width?: number, height?: number): string {
        if (width && height) {
            return this.getUrl('campaigns/image/' + id + '?width=' + width + '&height=' + height);
        } else {
            return this.getCDNUrl('campaigns/image/' + id);
        }
    }

    getCampaignThumbnailImageUrl(id: number, width?: number, height?: number): string {
        if (width && height) {
            return this.getUrl('campaigns/video/' + id + '/thumbnail?width=' + width + '&height=' + height);
        } else {
            return this.getUrl('campaigns/video/' + id + '/thumbnail');
        }
    }

    getCampaignVideoContentUrl(id: number): string {
        return this.getUrl('campaigns/video/' + id + '/contentMp4');
    }

    getSiteAddressUrl() {
        return this.siteAddressUrl;
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer.common/modules/services/api.serviceBase.ts